export enum FlightFilterType {
  ArrivalTimeFilters = 'arrivalTimeFilters',
  CarrierFilters = 'carrierFilters',
  DepartureTimeFilters = 'departureTimeFilters',
  MaxDurationInHours = 'maxDurationInHours',
  MaxNumberOfStops = 'maxNumberOfStops',
  PriceFilters = 'priceFilters',
}
